import React, { useState } from 'react';
import toast from 'react-hot-toast';
import apiService from '../../services/api';
import Button from '../UI/Button';
import Input from '../UI/Input';
import Modal from '../UI/Modal';

export interface CreateScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (schedule: { _id: string; name: string; description?: string }) => void;
}

const CreateScheduleModal: React.FC<CreateScheduleModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '' });

  const handleClose = () => {
    setFormData({ name: '', description: '' });
    onClose();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      toast.error('Schedule name is required');
      return;
    }
    try {
      setSubmitting(true);
      const res = await apiService.createSchedule({ name: formData.name.trim(), description: formData.description.trim() || undefined });
      const schedule = res.data?.schedule || res.data;
      toast.success('Schedule created successfully');
      onSuccess(schedule);
      handleClose();
    } catch (error: any) {
      toast.error(error.response?.data?.error || error.response?.data?.message || 'Failed to create schedule');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Create New Schedule" size="sm">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Name *"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Schedule name"
          required
          fullWidth
        />
        <Input
          label="Description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Optional description"
          fullWidth
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" onClick={handleClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" loading={submitting}>
            Create Schedule
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateScheduleModal;
